<template>
  <div :class="['menu-area', className]" v-show="show">
    <div class="menu-container">
      <div class="menu-header">
        <div class="header-content">
          <i :class="icon"></i>
          <span class="menu-title">{{ title }}</span>
        </div>
        <el-button type="primary" size="mini" @click="$emit('add')" title="新增">
          <i class="el-icon-plus"></i>
        </el-button>
      </div>
      <div class="menu-list">
        <loading-state v-if="loading" />
        <empty-state 
          v-else-if="list.length === 0"
          :icon="icon"
          :text="`暂无${title}`"
          :button-text="`创建第一个`"
          @create="$emit('add')">
        </empty-state>
        <menu-item
          v-else
          v-for="item in list" 
          :key="item.id"
          :item="item"
          :active="active === item.id"
          :type="type"
          @select="$emit('select', item)"
          @edit="$emit('edit', item)"
          @delete="$emit('delete', item)">
        </menu-item>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingState from './LoadingState.vue'
import EmptyState from './EmptyState.vue'
import MenuItem from './MenuItem.vue'

export default {
  name: 'MenuSection',
  components: {
    LoadingState,
    EmptyState,
    MenuItem
  },
  props: {
    title: String,
    icon: String,
    list: Array,
    loading: Boolean,
    active: [String, Number],
    show: { type: Boolean, default: true },
    className: String,
    type: String
  }
}
</script>

<style scoped>
.menu-area {
  width: 280px;
  border-right: 1px solid #f5f7fa;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
}

.menu-container {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.menu-header {
  padding: 16px 20px;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.header-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.header-content i {
  font-size: 16px;
  color: #00d8c3;
}

.menu-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.menu-list {
  height: calc(100% - 60px);
  overflow-y: auto;
  padding: 8px 0;
  background: #ffffff;
}

.menu-list::-webkit-scrollbar {
  width: 6px;
}

.menu-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.menu-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
  transition: background 0.3s ease;
}

.menu-list::-webkit-scrollbar-thumb:hover {
  background: #139AA5;
}
</style>